// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__33D4S","container":"Card_container__2pwYn","personal":"Card_personal__hWv_e","comment":"Card_comment__3YOzO"};